import TableComponent from "components/shared/Table";

import { Modal, ModalHeader, ModalBody, Label, Input } from "reactstrap";

function ResponseDetailsModal({ toggle, modal, selectedResponse }) {
  return (
    <div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Response Details Modal</ModalHeader>
        <ModalBody>
          <TableComponent
            className="align-items-center table-flush"
            responsive
            style={{ border: "1px solid #dee2e6", borderRadius: "5px" }}
          >
            <thead
              style={{ border: "1px solid #dee2e6" }}
              className="thead-light"
            >
              <tr>
                <th scope="col">Customer Name</th>
                <th scope="col">Customer Gender</th>
                <th scope="col">Customer Age</th>
              </tr>
            </thead>
            <tbody style={{ border: "1px solid #dee2e6" }}>
              <tr>
                <td scope="row">{selectedResponse.customerName || "N/A"}</td>
                <td scope="row">{selectedResponse.customerGender || "N/A"}</td>
                <td scope="row">{selectedResponse.customerAge || "N/A"}</td>
              </tr>
              <tr>
                <td colSpan={3}>
                  <div style={{ width: "100%" }}>
                    <Label for="responseText" style={{ fontWeight: "bold" }}>
                      Response
                    </Label>
                    <Input
                      type="textarea"
                      id="responseText"
                      value={selectedResponse.answer || ""}
                      readOnly
                      style={{
                        width: "100%",
                        whiteSpace: "pre-wrap",
                        overflowWrap: "break-word",
                        height: "150px",
                        border: "1px solid #ced4da",
                        borderRadius: "5px",
                        marginTop: "0.5rem",
                      }}
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </TableComponent>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default ResponseDetailsModal;
